import React from 'react'
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/form.module';


export default function TrainerBasicInfoComponent({ handleInnerFormChange, id, selectedTrainers }: any) {
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              isDisabled={id !== '0'}
              label="Phone"
              name="Phone"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Login.Phone',
                  selectedTrainers?.Login
                )
              }}
              type="number"
              value={selectedTrainers?.Login?.Phone}
            />
            <InputContainer
              isDisabled={id !== '0'}
              label="Email"
              name="Email"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Login.Email',
                  selectedTrainers?.Login
                )
              }}
              type="text"
              value={selectedTrainers?.Login?.Email}
            />
            {id === '0' && (
              <InputContainer
                icon
                label="Password"
                name="Password"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'Login.Password',
                    selectedTrainers?.Login
                  )
                }}
                type="password"
                value={selectedTrainers?.Login?.Password}
              />)}
            {id === '0' && (
              <InputContainer
                icon
                label="Confirm Password"
                name="ConfirmPassword"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'Login.ConfirmPassword',
                    selectedTrainers?.Login
                  )
                }}
                type="password"
                value={selectedTrainers?.Login?.ConfirmPassword}
              />
            )}


          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Basic Info"
      />

    </>
  )
}